// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1IVcc","content":"styles_content__3yZQS"};